import React from 'react';
import '../style/notifications.css';
import {Link} from "react-router-dom";
import moment from "moment";
import {parseComment} from '../helpers/commentParser'

const Notification = (props) => {
	let dateString = moment(props.item.createdAt).format('DD/MM/YYYY');
	let activeTab = 'application';
	if(props.item.eventName === "Update Required" || props.item.eventName === "Updated" || props.item.eventName === "No Changes")
		activeTab = 'update';
	if(props.item.eventName === "More Information Required" || props.item.eventName === "Information Provided")
		activeTab = 'overview';
	if(props.item.eventName === "Disbursement")
		activeTab = 'advancedDisbursements';
	if(props.item.eventName === "Application Form Change Approved"){
		activeTab = 'application';
	}

	if(props.item.eventName === "Application Form Change Rejected"){
		activeTab = 'overview';
	}

	if(props.item.eventName === "Request For Application Form Change"){
		activeTab = 'pendingChanges';
	}

	if(props.item.eventName === "Application Form Changed"){
		activeTab = 'overview';
	}

	const comment = parseComment(props.item.comment);

	return(
		<div className="row applicationsAndPolicies-wrapper">
			<div className="col-sm-12">
				<div className="row">
					<div className="col-sm-9 notification-data">
						{dateString}{' | '}{props.item.solicitorFileReference}{' - '}
						{props.item.customerName}{' | '}(ARAG ID: {props.item.aragId})
						| {props._getNotificationStatusText(props.item)}
						<span className="notification-event"> | {props.item.comment === "New application was created"? comment:props.item.eventName}</span>
						{" "} {props.item.comment !== "New application was created"? comment:null}
					</div>
					<div className="col-sm-3">
						<div className="notification-takeAction-wrapper">
							<Link
								className="notification-event"
								to={"/application-and-policies/application-policy/" + props.item.applicationId}
								onClick={()=> {
									props.requestPatchNotification(props.item.id, true, props.item.applicationId);
									props.getSelectedApplication(props.item.applicationId);
									setTimeout(() => props.receiveApplicationNotification(props.item),0);
									setTimeout(() => props.selectActiveTabNotification(activeTab, props.item.id, props.item.eventName),0)}
								}>
								<svg className="solicitorGroup-delete-arrow" xmlns="http://www.w3.org/2000/svg"
									 viewBox="0 0 7.2 12"><title>Asset 1</title>
									<g id="Layer_2" data-name="Layer 2">
										<g id="info">
											<path
												d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
										</g>
									</g>
								</svg>
								Take Action
							</Link>
						</div>
					</div>
				</div>
				<hr className="notifications-hr"/>
			</div>
		</div>
	);

};
export default Notification;
